import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { DokaSpinner, SpinnerSize } from '@doka/angular-core';

@Component({
  selector: 'app-spinner',
  template: `<doka-spinner [size]="size()" />`,
  host: { class: 'flex justify-center items-center w-full h-full' },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DokaSpinner],
})
export class SpinnerComponent {
  public readonly size = input<SpinnerSize>(SpinnerSize.Medium);
}
